import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "a",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M8.063,2.333c-3.164,0-5.729,2.565-5.729,5.729s2.565,5.729,5.729,5.729,5.729-2.565,5.729-5.729-2.565-5.729-5.729-5.729ZM.667,8.062C.667,3.978,3.978,.667,8.063,.667s7.396,3.311,7.396,7.396-3.311,7.396-7.396,7.396S.667,12.147,.667,8.062Z",
      "fill-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.113,12.114c.325-.325,.853-.325,1.179,0l3.797,3.797c.325,.325,.325,.853,0,1.179-.325,.326-.853,.326-1.178,0l-3.797-3.797c-.325-.325-.325-.853,0-1.179Z",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }